import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import i18n from 'i18next';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import { ComboBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';

import AddCircleIcon from '../../../../assets/icons/add-circle.svg?react';
import DeleteIcon from '../../../../assets/icons/delete.svg?react';

import './reminder.scss';

class Reminder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.temp = 'roleData';
    this.fields = { text: 'Text', value: 'Id', minutesvalue: '0' };
    this.fieldsList = { text: 'title', iconCss: 'icon' };
    this.onAddReminder = this.onAddReminder.bind(this);
    this.dataSource = [];

    this.datetimeData = [
      { Id: '1', Text: 'Minutos', Value: '60' },
      { Id: '2', Text: 'Horas', Value: '60' },
      { Id: '3', Text: 'Dias', Value: '60' },
      { Id: '4', Text: 'Semanas', Value: '60' }
    ];
  }

  componentDidMount() {
    if (this.props.onReady && this.listviewInstance) {
      this.props.onReady(this.listviewInstance);
    }

    this.syncListViewWithReminders(this.props.reminders || []);

    const btn = document.getElementById('btn-add-reminder');

    if (btn) {
      btn.addEventListener('click', this.onAddReminder);
    }
  }

  onAddReminder() {
    if (!this.listviewInstance || !this.ReminType || !this.numObj) {
      return;
    }

    const hasTypeValue =
      this.ReminType.value !== null &&
      this.ReminType.value !== undefined &&
      this.ReminType.value !== '';
    const hasNumericValue =
      this.numObj.value !== null &&
      this.numObj.value !== undefined &&
      this.numObj.value !== '';

    if (hasTypeValue && hasNumericValue) {
      const valueM = this.timeLogicTypetoMinutes(
        this.ReminType.value,
        this.numObj.value
      );
      const dataReminder = {
        title: 'email',
        value: valueM,
        minutesvalue: valueM,
        id: uuidv4(),
        icon: 'delete-icon'
      };
      this.listviewInstance.addItem([dataReminder]);
    }
  }

  deleteItem(args) {
    args.stopPropagation();
    const li = args.target.closest('li');
    this.listviewInstance.removeItem(li);
  }

  onChange() {
    if (this.ReminType && this.numObj) {
      switch (this.ReminType?.value) {
        case '1':
          //minutes
          this.numObj.max = 40320;
          break;
        case '2':
          //hours
          this.numObj.max = 672;
          break;
        case '3':
          //days
          this.numObj.max = 28;
          break;
        case '4':
          //weeks
          this.numObj.max = 4;
          break;
        default:
          this.numObj.max = 40320;
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.ReminType) {
      this.ReminType.value = '1';
    }

    if (!this.listviewInstance) {
      return;
    }

    const prevSignature = JSON.stringify(prevProps.reminders || []);
    const nextSignature = JSON.stringify(this.props.reminders || []);
    if (prevSignature !== nextSignature) {
      if (this.numObj) {
        this.numObj.value = 60;
      }
      this.syncListViewWithReminders(this.props.reminders || []);
    }
  }

  normalizeReminders(reminders = []) {
    return reminders.map((reminder) => {
      const rawMinutes = reminder?.minutesvalue ?? reminder?.value;
      const minutes = Number(rawMinutes);

      return {
        ...reminder,
        value: Number.isFinite(minutes) ? minutes : 0,
        minutesvalue: Number.isFinite(minutes) ? minutes : 0
      };
    });
  }

  syncListViewWithReminders(reminders = []) {
    if (!this.listviewInstance) {
      return;
    }

    const normalizedReminders = this.normalizeReminders(reminders);
    this.listviewInstance.dataSource = normalizedReminders;
    this.listviewInstance.dataBind();
  }

  timeLogicTypetoMinutes(type, value) {
    switch (type) {
      case '1':
        return value;
      case '2':
        //hours to minutes
        return value * 60;

      case '3':
        //days to minutes
        return value * 1440;

      case '4':
        //weeks to minutes
        return value * 10080;

      default:
        return value;
    }
  }

  timeMinutestoLogicType(time) {
    if (time / 24 / 60 / 7 >= 1 && Number.isInteger(time / 24 / 60 / 7)) {
      return `${time / 24 / 60 / 7} semanas`;
    }

    if (time / 24 / 60 >= 1 && Number.isInteger(time / 24 / 60)) {
      return `${time / 24 / 60} días`;
    }

    if ((time / 60) % 24 >= 1 && Number.isInteger((time / 60) % 24)) {
      // return time / 60 % 24 + " hours";
      return `${time / 60} horas`;
    }

    return `${time} ${this.ReminType.text}`;
  }

  listTemplate(data) {
    const value = this.timeMinutestoLogicType(data.value);
    return (
      <div className="e-list-wrapper"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '7px'
        }}
      >
        <span className="e-list-content">
          {i18n.t('calendar.reminder')} {value}
        </span>
        <DeleteIcon className="delete-icon" onClick={(e) => this.deleteItem(e)} />
      </div>
    );
  }

  render() {
    const { forwardedRef, layoutIframe } = this.props;
    return (
      <div ref={forwardedRef} id="reminder-wrapper" >
        <h3 className="title-reminder mb-3">{i18n.t('schedule.reminder')}</h3>
        <div>
          <ListViewComponent
            id="reminder-list"
            fields={this.fieldsList}
            template={this.listTemplate.bind(this)}
            ref={listview => {
              this.listviewInstance = listview;
            }}
          />
        </div>
        <div className={layoutIframe ? "form-reminder-iframe" : "form-reminder"}>
          <div>
            <div className="form-group">
              <div className="e-float-input">
                <NumericTextBoxComponent
                  format=""
                  value={this.numObj?.value || 60}
                  min="0"
                  max="4320"
                  ref={nun => {
                    this.numObj = nun;
                  }}
                ></NumericTextBoxComponent>
                <span className="reminder-divider reminder-divider-numeric" />
              </div>
              <div id="noError" />
            </div>
          </div>
          <div>
            <div className="form-group">
              <div className="e-float-input">
                <ComboBoxComponent
                  id="type"
                  floatLabelType='Never'
                  dataSource={this.datetimeData}
                  ref={combobox => {
                    this.ReminType = combobox;
                  }}
                  fields={this.fields}
                  change={this.onChange.bind(this)}
                  value={'1'}
                  popupHeight="220px"
                  allowCustom={false}
                />
                <span className="reminder-divider reminder-divider-time" />
              </div>
              <div id="noError" />
            </div>
          </div>
          <div className={layoutIframe ? 
            "btn-reminder-iframe-container ml-1" : 
              "btn-reminder-container ml-3"}>
                <ButtonComponent
                  id="btn-add-reminder"
                  cssClass="e-flat e-primary"
                  data-toggle="tooltip"
                  data-placement="top"
                  title={i18n.t('calendar.maximum_reminder_text')}
                  className="btn-add-reminder"
                >
                  <AddCircleIcon
                    className="lf-icon lf-icon-add-round reminder-add-icon"
                  />
                  {i18n.t('schedule.add_reminder')}
                </ButtonComponent>
          </div>
        </div>
      </div>
    );
  }
}

const ForwardedReminder = React.forwardRef((props, ref) => (
  <Reminder {...props} forwardedRef={ref} />
));

export default ForwardedReminder;
